import './floatingNav.css'

function FloatingNav() {
  return (
    <section id="floatingNav"></section>
  )
}

export default FloatingNav